import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/movimientorecepcion.css';

const SHELVES = Array.from({ length: 10 }, (_, i) => String(i + 1).padStart(2, '0'));

function MovimientoRecepcion() {
  const [shelf, setShelf] = useState('');
  const navigate = useNavigate();

  const handleContinue = () => {
    if (!shelf) return;
    // Navigate to the barcode scan step with RECEPCION-{shelf} as the scanCode
    navigate(`/storage/movimiento/RECEPCION-${shelf}`);
  };

  return (
    <div className="mov-recepcion-page">
      <button onClick={() => navigate('/storage')} className="mov-recepcion-back-button">
        &#8592;
      </button>

      <div className="mov-recepcion-container">
        <h1 className="mov-recepcion-title">Mover desde Recepción</h1>
        <p className="mov-recepcion-subtitle">Selecciona la posición de origen</p>

        <select
          className="mov-recepcion-select"
          value={shelf}
          onChange={(e) => setShelf(e.target.value)}
        >
          <option value="">Seleccionar posición...</option>
          {SHELVES.map((s) => (
            <option key={s} value={s}>
              RECEPCION-{s}
            </option>
          ))}
        </select>

        <button
          className="mov-recepcion-continue-button"
          onClick={handleContinue}
          disabled={!shelf}
        >
          Continuar
        </button>
      </div>
    </div>
  );
}

export default MovimientoRecepcion;
